import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class BookingSubCategoryStore {

    // Properties

    // Modal Create/Update Properties

    @observable showBookingSubCategoryModal = false;
    @observable bookingSubCategoryTitle = '';

    @observable tabNameActiveKey = '1';

    @observable bookingSubCategories = [];
    @observable id = 0;

    @observable bookingCategoryId = 0;
    @observable bookingCategoryName = '';

    @observable name = '';
    @observable nameEnglish = '';
    @observable nameChinese = '';
    @observable nameChineseTraditional = '';
    @observable nameThai = '';
    @observable nameJapanese = '';
    @observable nameVietnamese = '';

    @observable capacity = 1;
    @observable isAvailable = true;
    @observable maxHourPerDay = 0;
    @observable sortOrder = 0;

    @observable itemTextButton = 'Create';

    // Modal Search Booking Category Properties

    @observable showBookingCategorySearchModal = false;
    @observable lastChildBookingCategories = [];
    @observable lastChildBookingCategoryFilter = [];
    @observable bookingCategorySearchValue = '';

    // Helper Properties

    @observable bookingSubCategoryListLoading = false;
    @observable bookingSubCategoryModalLoading = false;

    // Initialization

    @action initBookingSubCategory() {
        this.bookingSubCategoryListLoading = true;

        ApiCaller.BookingSubCategories.getAll().then(responseFirst => {
            if (responseFirst && responseFirst.isSuccess) {
                var model = responseFirst.model;
                this.bookingSubCategories = model;

                ApiCaller.BookingCategories.getAll().then((responseSecond) => {
                    if (responseSecond && responseSecond.isSuccess) {
                        var model = responseSecond.model;
                        if (model.length > 0) {
                            this.lastChildBookingCategories = model;
                            this.lastChildBookingCategoryFilter = this.lastChildBookingCategories;
                        }
                    }

                    this.bookingSubCategoryListLoading = false;
                });
            } else {
                this.bookingSubCategories = [];
                this.bookingSubCategoryListLoading = false;
            }
        });
    }

    @action initCreateBookingSubCategory() {
        this.bookingSubCategoryTitle = 'Create Booking Sub Category';

        this.id = 0;
        this.bookingCategoryName = '';
        this.name = '';
        this.nameEnglish = '';
        this.nameChinese = '';
        this.nameChineseTraditional = '';
        this.nameThai = '';
        this.nameJapanese = '';
        this.nameVietnamese = '';
        this.capacity = 1;
        this.isAvailable = true;
        this.maxHourPerDay = 0;
        this.sortOrder = 0;
        this.itemTextButton = 'Create';
        this.showBookingSubCategoryModal = true;
    }

    @action initUpdateBookingSubCategory(id) {
        this.bookingSubCategoryModalLoading = true;
        this.bookingSubCategoryTitle = 'Update Booking Sub Category';
        this.itemTextButton = 'Save';
        this.showBookingSubCategoryModal = true;

        ApiCaller.BookingSubCategories.getById(id).then(response => {
            if (response && response.isSuccess) {
                var model = response.model;
                this.id = model.id;
                this.bookingCategoryId = model.bookingCategoryId;
                this.bookingCategoryName = model.bookingCategoryName;
                this.name = model.name;
                this.nameEnglish = model.nameLang.english;
                this.nameChinese = model.nameLang.chinese;
                this.nameChineseTraditional = model.nameLang.chineseTraditional;
                this.nameThai = model.nameLang.thai;
                this.nameJapanese = model.nameLang.japanese;
                this.nameVietnamese = model.nameLang.vietnamese;
                this.capacity = model.capacity;
                this.isAvailable = model.isAvailable;
                this.maxHourPerDay = model.maxHourPerDay;
                this.sortOrder = model.sortOrder;
                this.itemTextButton = 'Save';
                this.bookingSubCategoryModalLoading = false;
            }
        });
    }

    // TRANSACTION

    @action searchBookingCategory() {
        this.lastChildBookingCategoryFilter = this.lastChildBookingCategories.filter(category => {
            let categoryName = category.name.toLowerCase();
            return categoryName.indexOf(this.bookingCategorySearchValue.toLowerCase()) !== -1;
        });
    }

    @action searchBookingCategorySelected(id) {
        const category = this.lastChildBookingCategories.find(x => x.id === id);
        this.bookingCategoryId = id;
        this.bookingCategoryName = category.name;
    }

    // Transaction Item

    @action createBookingSubCategory() {
        this.bookingSubCategoryModalLoading = true;

        const request = {
            'bookingCategoryId': this.bookingCategoryId,
            'name': this.name,
            'nameLang': {
                'english': this.nameEnglish,
                'chinese': this.nameChinese,
                'chineseTraditional': this.nameChineseTraditional,
                'thai': this.nameThai,
                'japanese': this.nameJapanese,
                'vietnamese': this.nameVietnamese
            },
            'capacity': this.capacity,
            'isAvailable': this.isAvailable,
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingSubCategories.create(request).then((response) => {
            this.bookingSubCategoryModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingSubCategory();
                this.showBookingSubCategoryModal = false;
            }

            return response;
        });
    }

    @action updateBookingSubCategory() {
        this.bookingSubCategoryModalLoading = true;

        const request = {
            'id': this.id,
            'bookingCategoryId': this.bookingCategoryId,
            'name': this.name,
            'nameLang': {
                'english': this.nameEnglish,
                'chinese': this.nameChinese,
                'chineseTraditional': this.nameChineseTraditional,
                'thai': this.nameThai,
                'japanese': this.nameJapanese,
                'vietnamese': this.nameVietnamese
            },
            'capacity': this.capacity,
            'isAvailable': this.isAvailable,
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingSubCategories.update(request).then((response) => {
            this.bookingSubCategoryModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingSubCategory();
                this.showBookingSubCategoryModal = false;
            }

            return response;
        });
    }

    @action deleteUpdateBookingSubCategory(id) {
        this.bookingSubCategoryListLoading = true;

        return ApiCaller.BookingSubCategories.delete(id).then((response) => {
            this.bookingSubCategoryListLoading = false;
            if (response && response.isSuccess) {
                this.initBookingSubCategory();
            }
            return response;
        });
    }

    // SET Properties

    @action setShowBookingSubCategoryModal(value) {
        this.showBookingSubCategoryModal = value;
        if (!value) {
            this.tabNameActiveKey = '1';
        }
    }

    @action setShowBookingCategorySearchModal(value) {
        this.showBookingCategorySearchModal = value;
    }

    @action setBookingCategorySearchValue(value) {
        this.bookingCategorySearchValue = value
    }

    @action setNameEnglish(value) {
        this.nameEnglish = value;
        this.name = this.nameEnglish;
    }

    @action setNameChinese(value) {
        this.nameChinese = value;
    }

    @action setNameChineseTraditional(value) {
        this.nameChineseTraditional = value;
    }

    @action setNameThai(value) {
        this.nameThai = value;
    }

    @action setNameJapanese(value) {
        this.nameJapanese = value;
    }

    @action setNameVietnamese(value) {
        this.nameVietnamese = value;
    }

    @action setCapacity(value) {
        this.capacity = value;
    }

    @action setIsAvailable(value) {
        this.isAvailable = value;
    }

    @action setMaxHourPerDay(value) {
        this.maxHourPerDay = value;
    }

    @action setSortOrder(value) {
        this.sortOrder = value;
    }

    @action setTabNameActiveKey(value) {
        this.tabNameActiveKey = value;
    }
}

export default new BookingSubCategoryStore()
